import { useEffect, useRef, useState } from 'react';

import { COINS_SPREAD_SIZE, COIN_WIDTH, FADE_IN_DURATION_MS, TRANSITION_DURATION_MS } from './constants';
import type { XY } from './types';
import { getRandomNumber } from './utils';

type CoinProps = {
  start: XY;
  end: XY;
  timeOffset: number;
  onEnd?: () => void;
  gif: string;
  fadeInDurationMs?: number;
  transitionDurationMs?: number;
};

export function Coin(props: CoinProps) {
  const [cords, setCords] = useState({
    x: props.start.x + getRandomNumber(-COINS_SPREAD_SIZE - COIN_WIDTH, COINS_SPREAD_SIZE),
    y: props.start.y + getRandomNumber(-COINS_SPREAD_SIZE - COIN_WIDTH, COINS_SPREAD_SIZE),
  });

  const timeOut = useRef<ReturnType<typeof setTimeout>>();
  const transitionTimeOut = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    timeOut.current = setTimeout(
      () => {
        setCords({ ...props.end });
        transitionTimeOut.current = setTimeout(() => {
          if (typeof props.onEnd === 'function') {
            props.onEnd();
          }
        }, props.transitionDurationMs || TRANSITION_DURATION_MS);
      },
      (props.fadeInDurationMs || FADE_IN_DURATION_MS) + props.timeOffset * 1000,
    );
    return () => {
      clearTimeout(timeOut.current);
    };
  }, [props, props.end, props.timeOffset]);

  return (
    <img
      alt="coin"
      className={'coinFadeIn'}
      src={props.gif}
      style={{
        zIndex: 99999,
        width: `${COIN_WIDTH}px`,
        left: `${cords.x}px`,
        top: `${cords.y}px`,
        position: 'fixed',
        display: 'block',
        animationDelay: `${props.timeOffset}s`,
      }}
    />
  );
}
